module.exports = __webpack_public_path__ + "img/gift2.3b5a789b.png";